import type {
  Args as _Args,
  CountDistinct as _CountDistinct,
  DeleteWhere as _DeleteWhere,
  DropDatabase as _DropDatabase,
  Execute as _Execute,
  GeneratedDatabaseSchema as _GeneratedDatabaseSchema,
  GenericColumns as _GenericColumns,
  GenericRelation as _GenericRelation,
  GenericTable as _GenericTable,
  IDType as _IDType,
  Insert as _Insert,
  MigrateDownArgs as _MigrateDownArgs,
  MigrateUpArgs as _MigrateUpArgs,
  SQLiteD1Adapter as _SQLiteAdapter,
  SQLiteSchemaHook as _SQLiteSchemaHook,
} from '../types.js'

/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type SQLiteAdapter = _SQLiteAdapter

/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type Args = _Args
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type CountDistinct = _CountDistinct
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type DeleteWhere = _DeleteWhere
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type DropDatabase = _DropDatabase
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type Execute<T> = _Execute<T>
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type GeneratedDatabaseSchema = _GeneratedDatabaseSchema
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type GenericColumns = _GenericColumns
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type GenericRelation = _GenericRelation
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type GenericTable = _GenericTable
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type IDType = _IDType
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type Insert = _Insert
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type MigrateDownArgs = _MigrateDownArgs
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type MigrateUpArgs = _MigrateUpArgs
/**
 * @deprecated - import from `@payloadcms/db-sqlite` instead
 */
export type SQLiteSchemaHook = _SQLiteSchemaHook
